import {
    menuFinanceiro as conveniosExecucaoDiretaMenuPerfilFinanceiro,
    menuGestor as conveniosExecucaoDiretaMenuPerfilGestor,
    menuRelatorioDespesasReceitas as conveniosExecucaoDiretaMenuPerfilRelatorioDespesasReceitas,
} from './convenios/execucaodireta/menu';
import parametrosMenu from './parametros/menu';

const rmMenu = {
    label: 'Convênio de Execução',
    icon: 'pi pi-fw pi-briefcase',
    rules: [
        ...conveniosExecucaoDiretaMenuPerfilFinanceiro.rules,
        ...parametrosMenu.rules,
        ...conveniosExecucaoDiretaMenuPerfilGestor.rules,
        ...conveniosExecucaoDiretaMenuPerfilRelatorioDespesasReceitas.rules,
    ],
    items: [
        conveniosExecucaoDiretaMenuPerfilFinanceiro,
        parametrosMenu,
        conveniosExecucaoDiretaMenuPerfilGestor,
        conveniosExecucaoDiretaMenuPerfilRelatorioDespesasReceitas,
    ],
};

export default rmMenu;
